export class CommonRegData {
  role: string;
  parent_id: number;
  accept_private_policy: boolean;
  accept_terms_and_conditions: boolean;
}



// WEBPACK FOOTER //
// ./app/states/auth/models/common-reg-data.ts